export class SaveModifiedInputModel {
    attributeId: number;
    attributeName: string;
    attributeValueId: string;
    oldAttributeValue: string;
    newAttributeValue: string;
    allowAuditUpdate: boolean;
}


// WEBPACK FOOTER //
// ./src/app/modules/eldm-param-value/entities/save-modified-input-model.ts